import { Route } from "@angular/router";
import { AuthGuard } from "./core/auth/guards/auth.guard";

// @formatter:off

export const appRoutes: Route[] = [
  // Redirect empty path to '/example'
  { path: "", pathMatch: "full", redirectTo: "residus" },
  {
    path: "403",
    loadComponent: () =>
      import("@modules/error403/error403.component").then(
        (m) => m.Error403Component
      ),
  },
  {
    path: "404",
    loadComponent: () =>
      import("@modules/error403/error403.component").then(
        (m) => m.Error403Component
      ),
  },
  {
    path: "welcome",
    loadComponent: () => import("./modules/welcome/welcome.component").then((m) => m.WelcomeComponent),
  },
  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadComponent: () =>
      import("app/layout/layout.component").then((m) => m.LayoutComponent),
    resolve: {
      // initialData: initialDataResolver,
    },
    children: [
      // {
      //   path: "home",
      //   loadChildren: () => import("app/modules/landing/home/home.routes"),
      // },
      {
        path: "welcome",
        loadComponent: () => import("./modules/welcome/welcome.component").then((m) => m.WelcomeComponent),
      },
      {
        path: "residus",
        loadChildren: () => import("app/modules/residues/residues.routes"),
      },
      {
        path: "categoria",
        loadChildren: () => import("app/modules/categories/categories.routes"),
      },
      {
        path: "fraccions",
        loadChildren: () => import("app/modules/fractions/fractions.routes"),
      },
      {
        path: "punt-recollida",
        loadChildren: () =>
          import("app/modules/collecting-points/collecting-points.routes"),
      },
      {
        path: "horaris",
        loadChildren: () => import("app/modules/horaris/horaris.routes"),
      },
      {
        path: "informacio-secundaria",
        loadChildren: () =>
          import("app/modules/secondary-info/secondary-info.routes"),
      },
      {
        path: "tipus-servei",
        loadChildren: () =>
          import("app/modules/service-types/service-types.routes"),
      },
      {
        path: "especial",
        loadChildren: () => import("app/modules/special/special.routes"),
      },
      {
        path: "sinonims",
        loadChildren: () => import("app/modules/sinonims/sinonims.routes"),
      },
      { path: "**", redirectTo: "residus" },
    ],
  },
];
